import {
  Autocomplete,
  Box,
  Button,
  Grid,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { PersonalDetailsForm } from "../../model/personal_details/personal_details";
import { useFeedback } from "../../../../providers/feedback/feedback";

function PersonalDetails(props: PersonalDetailsForm) {
  const {
    fullName,
    setFullName,
    age,
    setAge,
    gender,
    setGender,
    contactDetails,
    setContactDetails,
    parentName,
    setParentName,
    email,
    setEmail,
    setSurveyStep,
    surveyStep,
    bloodGroup,
    setBloodGroup,
    bloodDonate,
    setBloodDonate,
    currentlyResiding,
    setCurrentlyResiding,
  } = props;

  const { showSnackbar } = useFeedback();

  let genderList = [
    { id: 1, value: "Male" },
    { id: 2, value: "female" },
    { id: 3, value: "other" },
  ];

  const bloodGroupList = [
    { id: 1, value: "A+" },
    { id: 2, value: "A−" },
    { id: 3, value: "B+" },
    { id: 4, value: "B−" },
    { id: 5, value: "AB+" },
    { id: 6, value: "AB−" },
    { id: 7, value: "O+" },
    { id: 8, value: "O−" },
  ];

  const currentLocationOptions = [
    { id: 1, value: "Within your Home Parish" },
    { id: 2, value: "Outside the Parish but within Karnataka" },
    { id: 3, value: "Outside Karnataka but within India" },
    { id: 4, value: "Outside India" },
  ];

  return (
    <Box mt={1}>
      <Box>
        <Typography fontWeight={600} variant="h5">
          Personal Details
        </Typography>
      </Box>
      <Grid container mt={1} spacing={4}>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            6. Full Name<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            sx={{ mt: 1 }}
            onChange={(e) => setFullName(e.target.value)}
            value={fullName}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            7. Age<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            type="number"
            fullWidth
            sx={{ mt: 1 }}
            onChange={(e) => {
              if (e.target.value === "") {
                setAge("");
              } else if (e.target.value.length <= 2) {
                setAge(+e.target.value);
              }
            }}
            value={age}
            InputProps={{
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
              },

              sx: {
                "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                  {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                "& input[type=number]": {
                  MozAppearance: "textfield", // Firefox
                },
              },
            }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              maxLength: 6,
            }}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            8. Gender<span style={{ color: "red" }}>*</span>
          </Typography>
          <Autocomplete
            sx={{ mt: 2 }}
            fullWidth
            value={
              genderList.find((option) => gender?.id === option.id) || null
            }
            onChange={(e, value) => {
              setGender(value);
            }}
            options={genderList}
            getOptionLabel={(option) => option.value || ""}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Gender" />
            )}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            9. Contact Details<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            type="number"
            fullWidth
            sx={{ mt: 1 }}
            onChange={(e) => {
              if (e.target.value === "") {
                setContactDetails("");
              } else if (e.target.value.length <= 10) {
                setContactDetails(+e.target.value);
              }
            }}
            value={contactDetails}
            InputProps={{
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
              },

              sx: {
                "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                  {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                "& input[type=number]": {
                  MozAppearance: "textfield", // Firefox
                },
              },
            }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              maxLength: 10,
            }}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            10.Where are you currently residing (for education, work, or other
            purposes)?
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <Autocomplete
            sx={{ mt: 2 }}
            fullWidth
            value={
              currentLocationOptions.find(
                (option) => currentlyResiding?.id === option.id
              ) || null
            }
            onChange={(e, value) => {
              setCurrentlyResiding(value);
            }}
            options={currentLocationOptions}
            getOptionLabel={(option) => option.value || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Currently residing"
              />
            )}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            11. Parent name<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            type="text"
            fullWidth
            sx={{ mt: 1 }}
            onChange={(e) => setParentName(e.target.value)}
            value={parentName}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            12. Email Id<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            type="Email"
            fullWidth
            sx={{ mt: 1 }}
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500}>
            13. Blood group<span style={{ color: "red" }}>*</span>
          </Typography>
          <Autocomplete
            sx={{ mt: 2 }}
            fullWidth
            value={
              bloodGroupList.find((option) => bloodGroup?.id === option.id) ||
              null
            }
            onChange={(e, value) => {
              setBloodGroup(value);
            }}
            options={bloodGroupList}
            getOptionLabel={(option) => option.value || ""}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Blood Group" />
            )}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={6} xl={6}>
          <Typography variant="subtitle1" fontWeight={500} mt={1}>
            14. Are you willing to donate blood when required?
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <Box display={"flex"} flexDirection={"row"}>
            <Box display={"flex"} flexDirection={"row"}>
              <Radio
                name="bloodDonate"
                value={true}
                checked={bloodDonate === true}
                onChange={() => setBloodDonate(true)}
              />
              <Typography ml={1} mt={1}>
                Yes
              </Typography>
            </Box>
            <Box display={"flex"} flexDirection={"row"} ml={2}>
              <Radio
                name="bloodDonate"
                value={false}
                checked={bloodDonate === false}
                onChange={() => setBloodDonate(false)}
              />
              <Typography ml={1} mt={1}>
                No
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          sm={6}
          xs={6}
          md={3}
          lg={3}
          xl={3}
          onClick={() => setSurveyStep(surveyStep - 1)}
        >
          <Button variant="contained" fullWidth size="large">
            Previous
          </Button>
        </Grid>
        <Grid item sm={6} xs={6} md={3} lg={3} xl={3}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={() => {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (emailRegex.test(email)) {
                setSurveyStep(surveyStep + 1);
              } else {
                showSnackbar("Please enter a valid email address", "#DC143C");
              }
            }}
            disabled={
              !fullName ||
              !age ||
              !gender ||
              !contactDetails ||
              !parentName ||
              !email ||
              !bloodGroup ||
              !currentlyResiding
            }
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PersonalDetails;
